import React from "react";
import SkeletonC from "../../stories/common/skeleton";
import styles from './index.module.scss'

export default function InvestorActivitySkeleton() {
  return (
    <div  className={styles.ActivitySkeleton}>
      <SkeletonC width="100%" height="55px" />
    </div>
  );
}
